enum BiteLogGloryEvent {
  OpenRequestSuccess = 1,
  OpenRequestError = 2,
  OccupancyRequestSuccess = 3,
  OccupancyRequestError = 4,
  RegisterEventRequestSuccess = 5,
  RegisterEventRequestError = 6,
  AdjustTimeRequestSuccess = 7,
  AdjustTimeRequestError = 8,
  GetStatusRequestSuccess = 9,
  GetStatusRequestError = 10,
  InventoryRequestSuccess = 11,
  InventoryRequestError = 12,
  CloseRequestSuccess = 13,
  CloseRequestError = 14,
  SaleTransactionSuccess = 15,
  SaleTransactionError = 16,
  ChangeCancelRequestSuccess = 17,
  ChangeCancelRequestError = 18,
  UpdateManualDepositRequestSuccess = 19,
  UpdateManualDepositRequestError = 20,
  StatusChangeEvent = 21,
  OpenSequenceSuccess = 22,
  OpenSequenceError = 23,
  ChangeResponseEvent = 24,
  TransactionInterrupted = 25,
  EventSubscriptionError = 26,
  KioskCashMachineStateChanged = 27,
  InventoryEventSuccess = 28,
  InventoryEventError = 29,
  ParseError = 30,
  CancelPaymentCashOutNotMatchCashIn = 31,
  TransactionCancelled = 32,
  TransactionCancellationError = 33,
}

export { BiteLogGloryEvent };
